
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDZkJjT4kKKz0NmtCQmqZAtuh6wB17YXNg",
  authDomain: "sah-vice.firebaseapp.com",
  projectId: "sah-vice",
  storageBucket: "sah-vice.firebasestorage.app",
  messagingSenderId: "297100407387",
  appId: "1:297100407387:web:28ed19ee8122b76dacc57e",
  measurementId: "G-PN36K29XM5"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services you need
export const auth = getAuth(app);

// To add other Firebase services, import them and export like this:
export const db = getFirestore(app); // Used for storing data like vehicles and members
export const storage = getStorage(app); // Used for uploading and storing images